"use strict";

import ItemView from "/js/interaction-views/item-view.js";
import BinaryButtonItemContentView from "/js/interaction-views/binary-button-item-content-view.js";

/**
 * A single step in the binary button interaction.
 */
export default class BinaryButtonItemView extends ItemView {

  makeContentView(questionObject, index, numItems) {
    return new BinaryButtonItemContentView(questionObject, index, numItems);
  }
}
